/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from 'react';
import './Contact.css';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    sservice: '',
    message: ''
  });

  const [showPopup, setShowPopup] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    const accessKey = process.env.REACT_APP_WEB3FORMS_ACCESS_KEY;
    
    if (!accessKey || accessKey === 'your_actual_access_key_here') {
      alert("Please configure your Web3Forms Access Key in the .env file.");
      setIsSubmitting(false);
      return;
    }

    try {
      const response = await fetch("https://api.web3forms.com/submit", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json"
        },
        body: JSON.stringify({
          access_key: accessKey,
          name: formData.name,
          email: formData.email,
          service: formData.service,
          message: formData.message,
          from_name: "Portfolio Contact Form"
        })
      });

      const data = await response.json();

      if (data.success) {
        setShowPopup(true);
        setFormData({
          name: '',
          email: '',
          service: '',
          message: ''
        });
      } else {
        console.error("Web3Forms Error:", data);
        alert(data.message || "Failed to send message. Please try again.");
      }
    } catch (error) {
      console.error("Submission Error:", error);
      alert("An error occurred while sending the message. Please check your internet connection.");
    } finally {
      setIsSubmitting(false);
    }
  };

  const closePopup = () => {
    setShowPopup(false);
  };

  return (
    <section className="section contact" id="contact">
      <div className="container">
        <div className="section-title">
          <h2>Contact Me</h2>
        </div>
        
        <div className="contact-content">
          <div className="contact-info">
            <h3>Let's Work Together</h3>
            <p>
              I'm always interested in new opportunities and exciting projects. 
              Feel free to reach out if you'd like to work together!
            </p>
            
            <div className="contact-items">
              <div className="contact-item">
                <div className="contact-icon">
                  <i className="fas fa-envelope"></i>
                </div>
                <div className="contact-details">
                  <h4>Email</h4>
                  <span>umarzayyar62@gmail.com</span>
                </div>
              </div>
              
              <div className="contact-item">
                <div className="contact-icon">
                  <i className="fas fa-phone"></i>
                </div>
                <div className="contact-details">
                  <h4>Phone</h4>
                  <span>+923107168191</span>
                </div>
              </div>
              
              <div className="contact-item">
                <div className="contact-icon">
                  <i className="fas fa-map-marker-alt"></i>
                </div>
                <div className="contact-details">
                  <h4>Location</h4>
                  <span>Sadhoki, Gujranwala, Pakistan</span>
                </div>
              </div>
            </div>
          </div>
          
          <div className="contact-form">
            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <input
                  type="text"
                  name="name"
                  placeholder="Your Name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                />
              </div>
              
              <div className="form-group">
                <input
                  type="email"
                  name="email"
                  placeholder="Your Email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                />
              </div>
              
              <div className="form-group">
                <input
                  type="text"
                  name="subject"
                  placeholder="Service name"
                  value={formData.subject}
                  onChange={handleChange}
                  required
                />
              </div>
              
              <div className="form-group">
                <textarea
                  name="message"
                  placeholder="Your Message"
                  rows="5"
                  value={formData.message}
                  onChange={handleChange}
                  required
                ></textarea>
              </div>
              
              <button type="submit" className="btn btn-primary btn-full" disabled={isSubmitting}>
                {isSubmitting ? 'Sending...' : 'Send Message'}
              </button>
            </form>
          </div>
        </div>

        {/* Success Popup */}
        {showPopup && (
          <div className="popup-overlay" onClick={closePopup}>
            <div className="popup-content" onClick={(e) => e.stopPropagation()}>
              <div className="popup-icon">
                <i className="fas fa-check-circle"></i>
              </div>
              <h3>Message Sent Successfully!</h3>
              <p>Thank you for your message! You can dirctly contact with me. If reply was late
                due to any problem.
              </p>
              <button className="popup-close-btn" onClick={closePopup}>
                Got It
              </button>
            </div>
          </div>
        )}
      </div>
    </section>
  );
};

export default Contact;